"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldTooltip = void 0;
const react_1 = require("react");
const component_size_1 = require("../../utils/component-size");
const lib_1 = require("use-debounce/lib");
function isEllipsisActive(ref) {
    const current = ref.current;
    return current !== null
        ? current.offsetWidth + 1 < current.scrollWidth // + 1 to prevent rounding errors
        : false;
}
function useFieldTooltip(value = '') {
    const tooltipRef = react_1.useRef(null);
    const [withTooltip, setWithTooltip] = react_1.useState(false);
    const { width } = component_size_1.useComponentSize(tooltipRef);
    const [debouncedWidth] = lib_1.useDebounce(width, 500);
    react_1.useLayoutEffect(() => {
        setWithTooltip(isEllipsisActive(tooltipRef));
    }, [value, debouncedWidth]);
    return { withTooltip, tooltipRef };
}
exports.useFieldTooltip = useFieldTooltip;
//# sourceMappingURL=tooltip-field-hook.js.map